
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite-codes",
      function () {
        return require("private-next-pages/invite-codes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite-codes"])
      });
    }
  